var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('selector',{ref:"selector",staticClass:"super-user-selector",attrs:{"mode":"multi","selectedKeys":_vm.selectedKeys,"selectOptions":_vm.superUserOptions,"theme":_vm.theme,"actions":_vm.selectorActions,"options":_vm.selectorOptions},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var option = ref.option;
return [_c('span',{staticClass:"text-black text-sm"},[_vm._v(_vm._s(option.value))])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }